import { jsPDF } from 'jspdf';

const ELIN_LOGO_ASSET_PATH = 'assets/Elin_(Unternehmen)_logo.svg';
let elinLogoDataUrlPromise: Promise<string | null> | null = null;

async function svgToPngDataUrl(svgText: string): Promise<string | null> {
  return new Promise((resolve) => {
    try {
      const svgBlob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
      const objectUrl = URL.createObjectURL(svgBlob);
      const image = new Image();

      image.onload = () => {
        try {
          const width = image.naturalWidth || 1024;
          const height = image.naturalHeight || 294;
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            URL.revokeObjectURL(objectUrl);
            resolve(null);
            return;
          }
          ctx.drawImage(image, 0, 0, width, height);
          const pngDataUrl = canvas.toDataURL('image/png');
          URL.revokeObjectURL(objectUrl);
          resolve(pngDataUrl);
        } catch {
          URL.revokeObjectURL(objectUrl);
          resolve(null);
        }
      };

      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(null);
      };

      image.src = objectUrl;
    } catch {
      resolve(null);
    }
  });
}

async function getElinLogoDataUrl(): Promise<string | null> {
  if (!elinLogoDataUrlPromise) {
    elinLogoDataUrlPromise = (async () => {
      try {
        const logoUrl = new URL(ELIN_LOGO_ASSET_PATH, document.baseURI).toString();
        const response = await fetch(logoUrl);
        if (!response.ok) return null;
        const svgText = await response.text();
        return await svgToPngDataUrl(svgText);
      } catch {
        return null;
      }
    })();
  }
  return elinLogoDataUrlPromise;
}

export async function drawPdfHeader(doc: jsPDF, title: string, subline: string): Promise<number> {
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFillColor(244, 247, 252);
  doc.rect(0, 0, pageWidth, 34, 'F');

  try {
    const logoDataUrl = await getElinLogoDataUrl();
    if (logoDataUrl) {
      doc.addImage(logoDataUrl, 'PNG', 12, 8, 46, 12);
    } else {
      throw new Error('Logo not available');
    }
  } catch {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(0, 95, 155);
    doc.text('ELIN', 12, 18);
  }

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.setTextColor(26, 26, 46);
  doc.text(title, pageWidth - 12, 16, { align: 'right' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(90, 98, 110);
  doc.text(subline, pageWidth - 12, 24, { align: 'right' });

  doc.setDrawColor(0, 95, 155);
  doc.setLineWidth(0.8);
  doc.line(12, 30, pageWidth - 12, 30);

  return 40;
}

export function drawSectionTitle(doc: jsPDF, y: number, title: string): number {
  const pageWidth = doc.internal.pageSize.getWidth();
  doc.setFillColor(248, 250, 252);
  doc.roundedRect(12, y - 5, pageWidth - 24, 8, 1.5, 1.5, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(26, 26, 46);
  doc.text(title, 14, y);
  return y + 8;
}
